"use client";

import { createContext, useCallback, useContext, useState, ReactNode } from "react";
type AiAgentContextType = {
  isOpen: boolean;
  toggleOpen: () => void;
  close: () => void;
};
const AiAgentContext = createContext<AiAgentContextType>({
  isOpen: false,
  toggleOpen: () => {},
  close: () => {}
});
export function useAiAgent() {
  return useContext(AiAgentContext);
}
export function AiAgentProvider({
  children
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpen = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);
  return <AiAgentContext.Provider value={{
    isOpen,
    toggleOpen,
    close
  }} data-sentry-element="AiAgentContext.Provider" data-sentry-component="AiAgentProvider" data-sentry-source-file="AiAgentProvider.tsx">
      {children}
    </AiAgentContext.Provider>;
}